<mat-chip-grid #chipGrid>
    <div class="container" [dragula]="dragulaGroup" [dragulaModel]="selectedOptions$ | async">
        @for (option of selectedOptions$ | async; track option; let index = $index) {
            <mat-chip-row [editable]="false" (removed)="remove(index)">
                <ng-container *ngTemplateOutlet="optionTemplateRef; context: { option: option }" />
                @if (isDeletable) {
                    <ui-icon name="remove" size="small" matChipRemove />
                }
            </mat-chip-row>
        }
    </div>
    <input
        matInput
        class="mdc-text-field__input advizeo-input"
        [ngModel]="search$ | async"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (ngModelChange)="handleSearchEvent($event)"
        (onBlur)="onTouched()"
    />
</mat-chip-grid>

<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @if (groupField) {
        @for (group of filteredOptionsGroup$ | async; track group) {
            <mat-optgroup [label]="group?.label">
                @for (option of group?.options; track option) {
                    <mat-option ngClass="ui-selectable-chip-option" [value]="option">
                        <ng-container *ngTemplateOutlet="optionTemplateRef; context: { option: option }" />
                    </mat-option>
                }
            </mat-optgroup>
        }
    } @else {
        @for (option of filteredOptions$ | async; track option) {
            <mat-option ngClass="ui-selectable-chip-option" [value]="option">
                <ng-container *ngTemplateOutlet="optionTemplateRef; context: { option: option }" />
            </mat-option>
        }
    }
</mat-autocomplete>
